// extracted by mini-css-extract-plugin
export var card = "_7t-0";
export var failedIcon = "_7t-4";
export var failedIconBadge = "_7t-3";
export var icon = "_7t-1";
export var successIcon = "_7t-2";